import { render } from "./positions.vue?vue&type=template&id=5f5d4a79"
import script from "./positions.vue?vue&type=script&lang=js"
export * from "./positions.vue?vue&type=script&lang=js"

import "./positions.vue?vue&type=style&index=0&id=5f5d4a79&lang=scss"

import exportComponent from "G:\\司机仓库\\warehouseModule\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__